import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrgIndividualTeamsComponent } from '../../org-individual-teams/org-individual-teams.component';
import { CommonDataService } from '../../common-data.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-roster-del-member-popup',
  templateUrl: './roster-del-member-popup.component.html',
  styleUrls: ['./roster-del-member-popup.component.scss']
})
export class RosterDelMemberPopupComponent {
  constructor(public orgIndivTeams: OrgIndividualTeamsComponent, public commonDataService: CommonDataService, private http: HttpClient) {}

  public close() {
    this.orgIndivTeams.modalSvc.showRosterDelMem = false;
  }

  public delRoster() {
    const mem = this.orgIndivTeams?.modalSvc?.removeRosterMemDetails;
    if (!mem) return;
    if (this.orgIndivTeams?.id == this.orgIndivTeams?.demo_roster_id) {
      this.orgIndivTeams.deleteAcmeRosterTeamMemberFn(mem);
      this.close();
    } else {
      this.orgIndivTeams.loading = true;
      const payload = { members_ids: [mem.id] };
      this.http.post(`${environment.profileURL}/api/v1/roster_organizations/${this.orgIndivTeams?.id}/remove_members`, payload)
        .subscribe({
          next: () => {
            this.orgIndivTeams.loading = false;
            this.cascadeRemoveFromTeams(mem);
            this.close();
            this.orgIndivTeams.roasterMembers();
          },
          error: () => {
            this.orgIndivTeams.loading = false;
            this.close();
          }
        });
    }
  }

  private cascadeRemoveFromTeams(member: any): void {
    const teamsNames = member?.teams_names || {};
    Object.entries(teamsNames).forEach(([teamId, teamName]: [string, any]) => {
      if (teamName === 'Unassigned' || teamName === 'Admin') return;
      const team = this.orgIndivTeams?.teams?.find((t: any) => String(t.id) === String(teamId));
      if (!team) return;
      team.memberships = (team.memberships || []).filter((mbr: any) =>
        String(mbr.member_id) !== String(member.id) && String(mbr.id) !== String(member.id)
      );
      if (team.memberships_count > 0) team.memberships_count -= 1;
    });
    if (this.orgIndivTeams?.teams) {
      this.orgIndivTeams.allTeamIdsTtl = this.orgIndivTeams.teams.map((t: any) => ({
        teamId: t.id,
        showMember: this.orgIndivTeams.defaultShowingMembers,
        teamName: t.name,
        memberships_count: t.memberships_count,
      }));
    }
  }

  public realTeamCount(teamsNames: any): number {
    if (!teamsNames) return 0;
    return Object.values(teamsNames).filter((v: any) => v !== 'Unassigned' && v !== 'Admin').length;
  }

  public realTeamNames(teamsNames: any): string[] {
    if (!teamsNames) return [];
    return Object.values(teamsNames).filter((v: any) => v !== 'Unassigned' && v !== 'Admin') as string[];
  }
}
